<template>
  <v-card>
    <div class="d-flex justify-space-between align-items-center py-6 pl-6">
      <CreateRoomForm :state="dialog" :subjects="subjects" @closeDialog="close" @refresh="getRooms" />
      <UpdateRoomForm
        :state="updateDialog"
        :subjects="subjects"
        :data="room"
        @closeDialog="closeUpdate"
        @refresh="getRooms"
      />
      <h5 class="text-uppercase align-self-center">Danh sách phòng thi</h5>
    </div>
    <div class="d-flex justify-content-between align-items-center pr-6" style="width: 100%">
      <RoomExcel @refresh="getRooms" />
      <v-btn color="primary" class="elevation-0" dark @click="openCreate">
        <v-icon left>mdi-plus</v-icon>Thêm phòng thi
      </v-btn>
    </div>

    <div class="pa-6">
      <v-card>
        <v-data-table
          item-key="id"
          :headers="computedHeaders"
          :loading="loading"
          :items="rooms"
          :items-per-page="pagination.itemsPerPage"
          :page.sync="pagination.page"
          :server-items-length="pagination.totalItems"
          :disable-sort="$vuetify.breakpoint.smAndDown"
          :footer-props="{ 'items-per-page-text': 'Số phòng mỗi trang' }"
          v-bind="this.$attrs"
          fixed-header
          @pagination="updatePagination"
        >
          <template v-slot:[`footer.page-text`]="items">
            Phòng thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} phòng
          </template>
          <template v-for="subject in subjects" v-slot:[`item.subject_${subject.id}`]="{ item }">
            <div :key="subject.id">
              <v-checkbox :input-value="hasSubject(item, subject.id)" disabled></v-checkbox>
            </div>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" @click="update(item)" v-bind="attrs" v-on="on" icon>
                    <v-icon> mdi-pencil </v-icon>
                  </v-btn>
                </template>
                <span>Chỉnh sửa phòng thi</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-card>
</template>

<script>
import CreateRoomForm from './CreateRoomForm.vue'
import { mapActions } from 'vuex'
import UpdateRoomForm from './UpdateRoomForm.vue'
import RoomExcel from './RoomExcel.vue'

const originHeaders = [
  {
    text: 'STT',
    value: 'index',
    align: 'left',
    sortable: false,
    show: true,
    width: '8%'
  },
  {
    text: 'Tên phòng thi',
    value: 'name',
    align: 'left',
    sortable: false,
    show: true,
    width: '15%'
  },
  {
    text: 'Mã phòng',
    value: 'code',
    align: 'left',
    sortable: false,
    show: true,
    width: '10%'
  },
  {
    text: 'Buổi',
    value: 'note',
    align: 'left',
    sortable: false,
    show: true,
    width: '10%'
  },
  {
    text: 'Số lượng',
    value: 'capacity',
    align: 'left',
    sortable: false,
    show: true,
    width: '10%'
  },
  {
    text: 'Địa điểm',
    value: 'location',
    align: 'left',
    sortable: false,
    show: true,
    width: '20%'
  },
  {
    text: 'Thao tác',
    value: 'actions',
    align: 'left',
    sortable: false,
    show: true,
    width: '8%'
  }
]

export default {
  props: {
    subjects: Array
  },
  data() {
    return {
      loading: false,
      headers: originHeaders,
      subjectHeaders: [],
      rooms: [],
      dialog: false,
      updateDialog: false,
      room: {
        name: '',
        code: '',
        location: '',
        note: '',
        subjects: []
      },
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0
      }
    }
  },
  computed: {
    computedHeaders() {
      const action = this.headers.findIndex(header => header.value === 'actions')
      const before = this.headers.slice(0, action)
      const after = this.headers.slice(action)
      return [...before, ...this.subjectHeaders, ...after]
    }
  },
  async created() {
    await this.getRooms()
  },
  methods: {
    ...mapActions('room', ['fetchRooms', 'countRooms']),
    async getRooms() {
      this.$loading.active = true
      this.loading = true
      const start = (this.pagination.page - 1) * this.pagination.itemsPerPage
      const limit = this.pagination.itemsPerPage
      try {
        this.pagination.totalItems = await this.countRooms({ exam: this.$route.params.id })
        this.rooms = await this.fetchRooms({
          _start: start,
          _limit: limit,
          exam: this.$route.params.id,
          _sort: 'index:ASC'
        })
      } catch (error) {
        this.$alert.error('Lỗi load thông tin phòng thi')
        console.error(error)
      } finally {
        this.loading = false
        this.$loading.active = false
      }
    },
    updatePagination(val) {
      this.pagination.page = val.page
      this.pagination.itemsPerPage = val.itemsPerPage
    },
    update(item) {
      this.room = item
      this.updateDialog = true
    },
    hasSubject(room, subjectId) {
      return room.subjects.some(subject => subject.id === subjectId)
    },
    openCreate() {
      this.dialog = true
    },
    close() {
      this.dialog = false
    },
    closeUpdate() {
      this.updateDialog = false
    }
  },
  watch: {
    subjects(newSubjects) {
      this.subjectHeaders = newSubjects.map(subject => ({
        text: subject.name,
        value: `subject_${subject.id}`,
        align: 'left',
        sortable: false,
        width: '10%'
      }))
    },
    'pagination.page'() {
      this.getRooms()
    },
    'pagination.itemsPerPage'() {
      this.getRooms()
    }
  },
  components: { CreateRoomForm, UpdateRoomForm, RoomExcel }
}
</script>
